var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.meta.loginFree || (_vm.saasInfo && _vm.userInfo))?_c('router-view'):_vm._e(),(_vm.printPDF)?_c('iframe',{ref:"print",staticStyle:{"position":"fixed","left":"100%","top":"0","width":"0","height":"0"},attrs:{"src":_vm.printPDF}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }